import { CompartmentCard } from "@/src/components/cards";
import { openDrawer } from "@/src/components/dialogs";
import {
  FetchableList,
  ListConstructor,
} from "@/src/components/fetchableLists";
import StaggeredAnimation from "@/src/components/staggeredAnimationComponent";
import {
  Patient,
  RefAnswer,
  antecedentsCategoriesIds,
} from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, jsonAbstract, uid } from "@/src/utils/utils";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import { FieldAnswersList } from "../fields/fieldsAnswersList";
import { AntecedentsDrawer } from "./antecedentsDrawer";
import { AntecedentsCard } from "./antecedentsCard";
import { FamilyMemberCard } from "./familyMemberCard";
import {
  FamilyAntecedentsCompartment,
  FamilyMembersAntecedentsList,
} from "./familyAntecedentsCompartment";

function AntecedentsCompartment({
  patient,
  color,
}: {
  patient: Patient;
  color?: "red" | "blue";
}) {
  const [reload, setReload] = useState(0);

  async function openAntecedentsDrawer(antecedents: RefAnswer[] | null) {
    let newAntecedents: RefAnswer[] = jsonAbstract(
      antecedents ||
        (await apiFetch("refAnswers", "loadMany", {
          categories: antecedentsCategoriesIds,
          patientId: patient.id || "",
        }))
    );

    openDrawer({
      id: "refAnswersDrawer",
      title: "Antécédents et FDR",
      additionalClasses: ["big"],
      content: (
        <AntecedentsDrawer
          antecedents={newAntecedents}
          patient={patient}
          onAntecedentsChange={(newValue) => {
            newAntecedents = newValue;
          }}
        />
      ),
      onConfirm: async () => {
        console.log("newAntecedents", newAntecedents);
        await apiFetch(
          "refAnswers",
          "addMany",
          {
            refAnswers: newAntecedents,
          },
          "Erreur lors de l'ajout des antécédents"
        );
        setReload((prev) => prev + 1);
      },
    });
  }

  return (
    <CompartmentCard
      title={"Antécédents et FDR"}
      className={color == "red" ? "red" : null}
      onClick={async () => {
        await openAntecedentsDrawer(null);
      }}
    >
      <div className="c1 gap15">
        <FetchableList
          queryKey={["AntecedentsCompartment", patient.id, reload]}
          queryFn={() =>
            apiFetch(
              "refAnswers",
              "loadMany",
              {
                categories: antecedentsCategoriesIds,
                patientId: getItemId(patient.id) || "",
              },
              "Erreur lors du chargement des antécédents"
            )
          }
        >
          {(antecedents) => {
            return (
              <div className=" grid c1 gap5">
                {antecedents?.map((antecedent, index) => {
                  return (
                    <StaggeredAnimation key={antecedent.id} index={index}>
                      <AntecedentsCard
                        antecedent={antecedent}
                        patient={patient}
                        onClick={async () => {
                          await openAntecedentsDrawer(antecedents);
                        }}
                      />
                    </StaggeredAnimation>
                  );
                })}
              </div>
            );
          }}
        </FetchableList>
        <FamilyMembersAntecedentsList
          originalPatient={patient}
          emptyChild={<div></div>}
          onAntecedentsChange={(newValue) => {
            setReload((prev) => prev + 1);
          }}
        ></FamilyMembersAntecedentsList>
      </div>
    </CompartmentCard>
  );
}

export { AntecedentsCompartment };
